import { Card, CardActions, CardContent, CardMedia, Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"
import { ImgComparisonSlider } from "@img-comparison-slider/react"
import './ComparisonSlider.css'

import MistLogo from '../../assets/images/webRedesign/mist_logo.png'
import DCartNew from '../../assets/images/webRedesign/new/cart_new.png'
import DCategoryNew from '../../assets/images/webRedesign/new/category_new.png'
import DHomepageNew from '../../assets/images/webRedesign/new/homepage_new.png'
import DProductNew from '../../assets/images/webRedesign/new/product_new.png'
import DCartOld from '../../assets/images/webRedesign/old/cart_old.png'
import DCategoryOld from '../../assets/images/webRedesign/old/category_old.png'
import DHomepageOld from '../../assets/images/webRedesign/old/homepage_old.png'
import DProductOld from '../../assets/images/webRedesign/old/product_old.png'
import MCartNew from '../../assets/images/webRedesign/new/mobile/cart_new.jpg'
import MCategoryNew from '../../assets/images/webRedesign/new/mobile/category_new.jpg'
import MHomepageNew from '../../assets/images/webRedesign/new/mobile/homepage_new.jpg'
import MProduct1New from '../../assets/images/webRedesign/new/mobile/product1_new.jpg'
import MProduct2New from '../../assets/images/webRedesign/new/mobile/product2_new.jpg'
import MCartOld from '../../assets/images/webRedesign/old/mobile/cart_old.jpg'
import MCategoryOld from '../../assets/images/webRedesign/old/mobile/category_old.jpg'
import MHomepageOld from '../../assets/images/webRedesign/old/mobile/homepage_old.jpg'
import MProduct1Old from '../../assets/images/webRedesign/old/mobile/product1_old.jpg'
import MProduct2Old from '../../assets/images/webRedesign/old/mobile/product2_old.jpg'


const WebsiteRedesign = ({ openWebRedesign, setOpenWebRedesign }) => {
  return (
    <>
      <Card sx={{ minWidth: 250, backgroundColor: '#18122B', margin: '1rem' }}>
        <CardMedia
          sx={{ height: 200 }}
          image={MistLogo}
          title='Website Redesign'
        />
        <CardContent>
          <Typography variant='h6' textAlign='center' sx={{ color: '#EDEBF7' }}>
            <strong>Website Redesign</strong>
          </Typography>
        </CardContent>
        <CardActions sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
          <Button
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
            variant="contained"
            onClick={() => setOpenWebRedesign(true)}
          >
            <strong>View More</strong>
          </Button>
        </CardActions>
      </Card>

      <Dialog
        fullWidth
        maxWidth='md'
        open={openWebRedesign}
        onClose={() => setOpenWebRedesign(false)}
      >
        <DialogTitle textAlign='center' sx={{ backgroundColor: "#18122B", color: '#EDEBF7' }}>
          Website Redesign
        </DialogTitle>
        <DialogContent sx={{ display: 'block', backgroundColor: "#18122B" }}>

          <Typography variant="body1" sx={{ color: '#EDEBF7' }}>
            Collaborating with a fellow developer, we undertook a full-scale overhaul of a WooCommerce website, breathing new life into its online presence. Our objective was to elevate user experience, streamline functionality, and introduce a contemporary design.
            <br></br>
            We crafted a fully customizable theme, providing the client with the ability to personalize elements such as banners, navigation, and blogs to align with their brand identity.
            <br></br>
            Consciously minimizing plugin usage, we ensured a lightweight and efficient website. This decision not only enhanced performance but also minimized potential conflicts between different plugins.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }} component='div'>
            Check out the new website <a href="https://mistparfumerija.ba/" target="_blank" rel='noreferrer'><strong style={{ color: '#D1C7F0', textDecoration: 'none' }}>here</strong></a>.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }} component='div'>
            Technologies used:
            <ul>
              <li>Wordpress</li>
              <li>Javascript</li>
              <li>PHP</li>
              <li>HTML</li>
              <li>CSS</li>
            </ul>
          </Typography>

          <Typography variant="h6" sx={{ color: '#EDEBF7', textAlign: 'center' }}>
            Before & After
          </Typography>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={DHomepageOld} alt="Homepage old" />
              <img slot="second" width={'100%'} src={DHomepageNew} alt="Homepage new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={DCategoryOld} alt="Category old" />
              <img slot="second" width={'100%'} src={DCategoryNew} alt="Category new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={DCartOld} alt="Cart old" />
              <img slot="second" width={'100%'} src={DCartNew} alt="Cart new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={DProductOld} alt="Product old" />
              <img slot="second" width={'100%'} src={DProductNew} alt="Product new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={MHomepageOld} alt="Mobile homepage old" />
              <img slot="second" width={'100%'} src={MHomepageNew} alt="Mobile homepage new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={MCategoryOld} alt="Mobile category old" />
              <img slot="second" width={'100%'} src={MCategoryNew} alt="Mobile category new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={MCartOld} alt="Mobile cart old" />
              <img slot="second" width={'100%'} src={MCartNew} alt="Mobile cart new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={MProduct1Old} alt="Mobile product old" />
              <img slot="second" width={'100%'} src={MProduct1New} alt="Mobile product new" />
            </ImgComparisonSlider>
            <ImgComparisonSlider>
              <img slot="first" width={'100%'} src={MProduct2Old} alt="Mobile product old" />
              <img slot="second" width={'100%'} src={MProduct2New} alt="Mobile product new" />
            </ImgComparisonSlider>
          </div>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#18122B" }}>
          <Button
            onClick={() => setOpenWebRedesign(false)}
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default WebsiteRedesign